var isLayerReady = function isLayerReady(layerProvider, layerId) {
  var layer = layerProvider.getLayer(layerId);

  if (layer) {
    return layer.readyToRender;
  }
};

export { isLayerReady as default, isLayerReady };
